import React from "react";

const OthersStacks = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Outras Stacks</h3>
      <div className="skills__box">

        <div className="skills__group">
          <div className="skills__data">
            <a href="https://www.docker.com/" target="_blank" rel="noreferrer" title="Docker">
              <i class="devicon-docker-plain bx-lg" />
            </a>
            <div>
              <a href="https://kubernetes.io/pt-br/" target="_blank" rel="noreferrer" title="Kubernetes">
                <i class="devicon-kubernetes-plain bx-lg" />
              </a>
            </div>
          </div>

          {/* <div className="skills__data">
           <a href="https://eslint.org/" target="_blank" rel="noreferrer" title="Eslint">
            <i class="devicon-eslint-original bx-lg" />
          </a>
              <div>
              <a href="https://graphql.org/" target="_blank" rel="noreferrer" title="Graphql">
                <i class="devicon-graphql-plain bx-lg" />
              </a>
            </div> 
          </div> */}

          {/* <div className="skills__data">
            <a href="https://kafka.apache.org/" target="_blank" rel="noreferrer" title="Kafka">
              <i class="devicon-apachekafka-original bx-lg" />
            </a>
            <div>
            <a href="https://jestjs.io/pt-BR/" target="_blank" rel="noreferrer" title="Jest">
              <i class="devicon-jest-plain bx-lg" />
            </a>
            </div>
          </div> */}

          {/* <div className="skills__data">
            <a href="https://mochajs.org/" target="_blank" rel="noreferrer" title="Mocha">
              <i class="devicon-mocha-plain bx-lg" />
            </a>
            <div>
              <a href="https://socket.io/" target="_blank" rel="noreferrer" title="Sockets">
                <i class="devicon-socketio-original bx-lg" />
              </a>
            </div>
          </div> */}
        </div>

        <div className="skills__group">
          <div className="skills__data">
            <a href="https://www.nginx.com/" target="_blank" rel="noreferrer" title="Nginx"> 
              <i class="devicon-nginx-original bx-lg" />
            </a>
            <div>
            <a href="https://git-scm.com/" target="_blank" rel="noreferrer" title="Git">
              <i class="devicon-git-plain bx-lg" />
            </a>
            </div>
          </div>

          {/* <div className="skills__data">
            <a href="https://spring.io/projects/spring-boot" target="_blank" rel="noreferrer" title="Spring Boot">
              <i class="devicon-spring-plain bx-lg" />
            </a>
            <div>
              <a href="https://nextjs.org/" target="_blank" rel="noreferrer" title="Next">
                <i class="devicon-nextjs-original bx-lg" />
              </a>
            </div>
          </div> */}

          {/* <div className="skills__data">
            <a href="https://tailwindcss.com/" target="_blank" rel="noreferrer" title="Tailwind">
              <i class="devicon-tailwindcss-plain bx-lg" />
            </a>
            <div> 
              <a href="https://mui.com/" target="_blank" rel="noreferrer" title="Material UI">
                <i class="devicon-materialui-plain bx-lg" />
              </a>
            </div>
          </div> */}
            
          {/* <div className="skills__data">
            <a href="https://developer.mozilla.org/pt-BR/docs/Web/HTML" target="_blank" rel="noreferrer" title="HTML">
              <i class="devicon-html5-plain bx-lg" />
            </a>
            <div>
              <a href="https://developer.mozilla.org/pt-BR/docs/Web/CSS" target="_blank" rel="noreferrer" title="CSS">
                <i class="devicon-css3-plain bx-lg" />
              </a>
            </div>
          </div> */}

        </div>

        <div className="skills__group">
          <div className="skills__data">
            <div>
              <a href="https://eslint.org/" target="_blank" rel="noreferrer" title="Eslint">
                <i class="devicon-eslint-original bx-lg" />
              </a>
            </div>
          </div>

          {/* <div className="skills__data">
            <div>
              <a href="https://www.postgresql.org/" target="_blank" rel="noreferrer" title="Postgresql">
                <i class="devicon-postgresql-plain bx-lg" />
              </a>
            </div>
          </div> */}

          {/* <div className="skills__data">
            <div>
              <a href="https://www.mongodb.com/pt-br" target="_blank" rel="noreferrer" title="Mongodb">
                <i class="devicon-mongodb-plain bx-lg" />
              </a>
            </div>
          </div> */}
            
          {/* <div className="skills__data">
            <div>
              <a href="https://redis.io/" target="_blank" rel="noreferrer" title="Redis">
                <i class="devicon-redis-plain bx-lg" />
              </a>
            </div>
          </div> */}

        </div>

      </div>
    </div>
  );
};

export default OthersStacks;
